import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import { fetchOrdersForManualEvaluation } from '../services/orderService';
import { updateManualScore } from '../services/evaluationService';

const ManualEvaluationPage = () => {
  const [orders, setOrders] = useState([]);
  const [scores, setScores] = useState({});
  const [loading, setLoading] = useState(false);
  const [noOrdersMessage, setNoOrdersMessage] = useState('');
  const [initialMessage, setInitialMessage] = useState('Orders whose order_status is <strong>"Under Review"</strong> and evaluation_status is <strong>"Passed_in_auto_evaluation"</strong> will appear here.');

  const handleFetchOrders = async () => {
    console.log('[ManualEvaluation] Fetch button clicked...');
    setLoading(true);
    setNoOrdersMessage(''); // Clear the message each time a fetch is attempted

    try {
      const filtered = await fetchOrdersForManualEvaluation();
      console.log('[ManualEvaluation] Filtered Orders:', filtered);

      if (filtered.length === 0) {
        setNoOrdersMessage('No orders for manual evaluation as of now.');
      }

      setOrders(filtered);
    } catch (err) {
      console.error('[ManualEvaluation] Failed to fetch orders:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleScoreChange = (orderId, value) => {
    setScores(prev => ({
      ...prev,
      [orderId]: value
    }));
  };

  const handleSubmit = async (order) => {
    const manualScore = parseFloat(scores[order.order_id]);
    if (isNaN(manualScore) || manualScore < 0 || manualScore > 35) {
      alert('Score must be between 0 and 35.');
      return;
    }

    // Confirmation dialog before submission
    const confirmed = window.confirm(`Are you sure you want to submit the score of ${manualScore} for Order ID ${order.order_id}?`);

    if (!confirmed) {
      console.log('[ManualEvaluation] Submission cancelled by user.');
      return;
    }

    try {
      console.log(`[ManualEvaluation] Submitting manual score for Order ID ${order.order_id}: ${manualScore}`);
      await updateManualScore(order.order_id, manualScore);
      alert(`Manual score submitted for Order ${order.order_id}`);
      
      // Re-fetch the orders after submission
      handleFetchOrders();
    } catch (error) {
      console.error('[ManualEvaluation] Error submitting score:', error);
      alert('Submission failed.');
    }
  };

  useEffect(() => {
    console.log('[ManualEvaluation] Orders updated:', orders);
  }, [orders]);

  const safeText = (text) => {
    if (text === null || text === undefined || text === '') return 'Not available';
    return text;
  };

  return (
    <div className="flex h-screen">
      <Sidebar />
      <div className="flex-1 p-6 overflow-auto">
        <h1 className="text-2xl font-bold mb-1">Manual Evaluation</h1>

        {/* Display the initial message with HTML rendering */}
        <p className="mb-6 text-gray-700" dangerouslySetInnerHTML={{ __html: initialMessage }} />

        <button
          onClick={handleFetchOrders}
          className="mb-6 bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          disabled={loading}
        >
          {loading ? 'Fetching...' : 'Fetch Orders for Manual Evaluation'}
        </button>

        {/* If there are no orders, show the message */}
        {noOrdersMessage ? (
          <p className="text-red-500">{noOrdersMessage}</p>
        ) : (
          <div className="space-y-6">
            {orders.map(order => (
              <div key={order.order_id} className="bg-white p-4 shadow rounded">
                <h2 className="font-semibold text-lg mb-2">Order ID: {order.order_id}</h2>

                <div className="text-sm text-gray-800 whitespace-pre-wrap mb-2">
                  <strong>Task ID:</strong> {safeText(order.task_id)}
                </div>
                <div className="text-sm text-gray-800 whitespace-pre-wrap mb-2">
                  <strong>Task Title:</strong> {safeText(order.task_title)}
                </div>
                <div className="text-sm text-gray-800 whitespace-pre-wrap mb-2">
                  <strong>Task Description:</strong>
                  <p>{safeText(order.task_description)}</p>
                </div>
                <div className="text-sm text-gray-800 whitespace-pre-wrap mb-3">
                  <strong>Max Payout:</strong> ₹{safeText(order.max_payout)}
                </div>

<div className="text-sm text-gray-800 whitespace-pre-wrap mb-3">
  <strong>Submission Text:</strong>
  <p dangerouslySetInnerHTML={{ __html: order.submission_text }} />
</div>


                <label className="block text-sm font-medium">Manual Score (out of 35)</label>
                <input
                  type="number"
                  value={scores[order.order_id] || ''}
                  onChange={(e) => handleScoreChange(order.order_id, e.target.value)}
                  className="w-32 mt-1 border px-3 py-1 rounded"
                />

                <button
                  className="mt-3 bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
                  onClick={() => handleSubmit(order)}
                >
                  Submit Evaluation
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ManualEvaluationPage;
